import { FirebaseError } from 'firebase/app';
import { collection, getCountFromServer } from 'firebase/firestore';

import { db } from '../../config';

export const fetchCollectionCount = async (
  collectionPath: string,
): Promise<number> => {
  try {
    const collectionRef = collection(db, collectionPath);
    const snapshot = await getCountFromServer(collectionRef);

    return snapshot.data().count;
  } catch (error) {
    throw new FirebaseError('failed-to-count', 'Error fetching collection count');
  }
};
